export default __webpack_public_path__ + "static/media/mc_symbol.75fc2cf1.svg";